ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
_ = require 'underscore'
l = require 'lib/localize'
Auth = require 'db/auth'

module.exports =
  routes: [['*splat', 'displayErrorPage']]

  displayErrorPage: (opts) ->
    data = _.extend { errorType: 'notFound' }, opts,
      url: location.pathname + location.search
      isLoggedIn: Auth.isLoggedIn()

    @errorView { title: l('error'), data }



// WEBPACK FOOTER //
// ./app/scripts/controller/catchall-route.coffee